import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import SEO from '../components/SEO/SEO';
import { fetchSEO } from '../store/slices/seoSlice';

const AboutPage = () => {
  const dispatch = useDispatch();
  const settings = useSelector((state) => state.settings.data);

  useEffect(() => {
    dispatch(fetchSEO('about'));
  }, [dispatch]);

  const ourStory = settings?.ourStory || {
    paragraph1: '',
    paragraph2: ''
  };

  const statistics = settings?.statistics || {
    happyCustomers: '',
    productsDelivered: '',
    citiesServed: '',
    yearsOfExcellence: ''
  };

  const joinOurJourney = settings?.joinOurJourney || {
    heading: '',
    description: ''
  };

  return (
    <>
      <SEO
        page="about"
        title={settings?.companyName ? `About Us - ${settings.companyName}` : "About Us - Our Story & Mission"}
        description={settings?.joinOurJourney?.description || settings?.ourStory?.paragraph1 || ""}
        keywords="about, company, our story"
        url="/about"
      />
      {/* Hero Banner - Luxe Style */}
      <section className="py-24 lg:py-32 bg-gray-50">
        <div className="mx-auto max-w-7xl px-6 lg:px-8 text-center">
          <p className="text-xs font-sans font-medium uppercase tracking-[0.3em] text-primary mb-6">
            About Us
          </p>
          <h1 className="font-serif text-5xl md:text-6xl font-light text-gray-900 mb-6">
            Our Story
          </h1>
        </div>
      </section>

      <div className="container mx-auto px-4 py-16">
      <div className="max-w-4xl mx-auto">
        <div className="prose max-w-none mb-12">
          {ourStory.paragraph1 && (
            <p className="text-lg text-gray-700 mb-6">
              {ourStory.paragraph1}
            </p>
          )}
          {ourStory.paragraph2 && (
            <p className="text-lg text-gray-700 mb-6">
              {ourStory.paragraph2}
            </p>
          )}
          {!ourStory.paragraph1 && !ourStory.paragraph2 && (
            <p className="text-lg text-gray-700 mb-6">
              {settings?.companyName ? `Welcome to ${settings.companyName}.` : ''} {settings?.joinOurJourney?.description || ''}
            </p>
          )}
        </div>

        {(statistics.happyCustomers || statistics.productsDelivered || statistics.citiesServed || statistics.yearsOfExcellence) && (
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-16">
            {[
              { number: statistics.happyCustomers, label: 'Happy Customers' },
              { number: statistics.productsDelivered, label: 'Products Delivered' },
              { number: statistics.citiesServed, label: 'Cities Served' },
              { number: statistics.yearsOfExcellence, label: 'Years of Excellence' },
            ].filter(stat => stat.number).map((stat, idx) => (
              <div key={idx} className="text-center">
                <div className="text-4xl font-bold text-black mb-2">{stat.number}</div>
                <div className="text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        )}

        {(joinOurJourney.heading || joinOurJourney.description) && (
          <div className="bg-surface rounded-lg p-8 text-center mb-8">
            {joinOurJourney.heading && (
              <h2 className="font-heading text-3xl font-bold text-black mb-4">{joinOurJourney.heading}</h2>
            )}
            {joinOurJourney.description && (
              <p className="text-gray-700 mb-6">
                {joinOurJourney.description}
              </p>
            )}
          </div>
        )}
        
        {/* Action Buttons - Always visible */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/products"
            className="bg-primary text-white px-8 py-3 rounded-lg hover:bg-primary-dark transition text-center"
          >
            Explore Products
          </Link>
          <Link
            to="/contact"
            className="bg-transparent border-2 border-primary text-primary px-8 py-3 rounded-lg hover:bg-primary hover:text-white transition text-center"
          >
            Get in Touch
          </Link>
        </div>
      </div>
      </div>
    </>
  );
};

export default AboutPage;

